import { isMac } from './isMac'

export const CMD_OR_CTRL_PLUS_ENTER = isMac ? 'command+enter' : 'ctrl+enter'
